import React from 'react'
import {Box, Container, Typography, Button} from '@mui/material'
import {
  IconHike,
  IconMgmt,
  IconTrip,
  IconVacation,
} from '../Icons'

export default function HomePage() {
  return (
    <Container maxWidth="md">
      <Typography variant="body1" sx={{my: 5}}>
        FotoLog is a web application designed to help curate, map points of interest, and share photographs (fotos) with others. While your original fotos are stored and can be exported, this application is not designed as a general-purpose solution for backup & storage of all of your fotos. View one of the public trips to understand a bit how it works:
      </Typography>
      <Box textAlign="center">
        <Button variant="contained" sx={{mx: 'auto'}} href="/globe">
          <IconTrip fontSize="large" /> &nbsp; View Public Trips
        </Button>
      </Box>
      <Typography variant="h1" mt={5}>
        Use Cases
      </Typography>
      <Box my={5}>
        <Typography variant="h2" display="flex">
          <IconVacation sx={{mr: 2, fontSize: '4rem'}} color="primary" />
          Travel Logs
        </Typography>
        <Typography variant="body1" pl="5rem">
          Share with friends & family without having to worry about platform buy-in & lock-in.
        </Typography>
      </Box>
      <Box my={5}>
        <Typography variant="h2" display="flex">
          <IconHike sx={{mr: 2, fontSize: '4rem'}} color="primary" />
          Excursions
        </Typography>
        <Typography variant="body1" pl="5rem">
          Good for trip reports and marking points of interest such as food caches & water holes.
        </Typography>
      </Box>
      <Box my={5}>
        <Typography variant="h2" display="flex">
          <IconMgmt sx={{mr: 2, fontSize: '4rem'}} color="primary" />
          Site Management
        </Typography>
        <Typography variant="body1" pl="5rem">
          Forestry, trail, and park stewards can use to identify points that need attention as well as manage &
          communicate the progress of their activities.
        </Typography>
      </Box>
      {/* <Typography variant="h1" mt={5}>
        Roadmap
      </Typography>
      <Box my={5}>
        <Typography variant="h2" display="flex">
          <IconFotoBook sx={{mr: 2, fontSize: '4rem'}} color="primary" /> Print
        </Typography>
        <Typography variant="body1" pl="5rem">
          Publish one or more trips as a PDF (perhaps with some basic layout customization) as another means to share with others.
        </Typography>
      </Box>
      <Box my={5}>
        <Typography variant="h2" display="flex">
          <IconVideo sx={{mr: 2, fontSize: '4rem'}} color="primary" /> Video
        </Typography>
        <Typography variant="body1" pl="5rem">
          Videos from 3rd parties such as YouTube & Vimeo can be embedded into your trips.
        </Typography>
      </Box>
      <Box my={5}>
        <Typography variant="h2" display="flex">
          <IconFotoEdit sx={{mr: 2, fontSize: '4rem'}} color="primary" /> Editing
        </Typography>
        <Typography variant="body1" pl="5rem">
          Ability to perform basic editing actions such as cropping, rotating, resizing, and applying filters.
        </Typography>
      </Box> */}
    </Container>
  )
}
